import React from 'react';
import I18n from 'modules/i18n';
import { IApiUnit } from '@/components/common/ProfessionalDevelopment/useProfessionalDevelopmentData';
import ProfessionalDevelopmentCard from '@/components/common/ProfessionalDevelopment/ProfessionalDevelopmentCard';
import { ApolloProvider } from '@apollo/client';
import apolloClient from '@/components/common/ApolloClient';
import Text from '@/components/ui/Text';

interface UnitSectionProps {
  data: IApiUnit[];
  pdProgramId: number;
  programId: number;
  userId: number;
}

const NoResultsMessage = () => (
  <div>
    <Text className="tw-text-center tw-mb-[2rem] tw-mt-[10rem]" variant="heading3">
      {I18n.t('no_courses_found')}
    </Text>
    <Text className="!tw-text-base tw-text-center" variant="body" weight="normal">
      {I18n.t('please_modify_filters')}
    </Text>
  </div>
);

const UnitSection = ({ data, pdProgramId, programId, userId }: UnitSectionProps) => {
  if (data.map(unit => unit.slide_shows).flat().length === 0) return <NoResultsMessage />;

  return (
    <ApolloProvider client={apolloClient}>
      {data.map(unit => (
        <div className="tw-ml-12" key={unit.id}>
          <Text size="lg" variant="body" weight="bold">{unit.title}</Text>
          <Text className="tw-mb-6 tw-text-gray-500" size="sm" variant="body" weight="normal">{unit.subtitle}</Text>
          <div className="tw-grid tw-gap-12 tw-grid-cols-3">
            {unit.slide_shows.map(slideShow => (
              <ProfessionalDevelopmentCard
                key={slideShow.id}
                slideShow={slideShow}
                pdProgramId={pdProgramId}
                programId={programId}
                userId={userId}
              />
            ))}
          </div>
        </div>
      ))}
    </ApolloProvider>
  );
};

export default UnitSection;
